import { Component, Inject, Vue } from 'vue-property-decorator';
import { InvitationCodeService } from '@/service/Invitation-code.service';
import { convertDateToCustomFormat } from '@/util/date-util';
import { InviteHistory } from '@/shared/model/invitation-code.model';
import { COUNTRIES } from '@/constants';
import RegisterService from '@/account/register/register.service';

@Component({
  methods: {
    convertDateToCustomFormat,
  },
})
export default class PaymentInviteComponent extends Vue {
  @Inject('invitationCodeService')
  private invitationCodeService: () => InvitationCodeService;

  @Inject('registerService') private registerService: () => RegisterService;

  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  userId;
  recentSignUps = [];
  notSignUps = [];
  referralList = Array.from({ length: 9 }, () => ({ isActive: false, isNotice: false })); // referralList's length always is 9
  isMobile = false;
  invitees = Array.from({ length: 1 }, () => ({ value: '', countryCode: '' }));
  countries = COUNTRIES;
  isInvalid = false;
  isInvalidCountryCode = false;
  isExist = false;
  dataValidated = [];
  isLoading = false;
  isWaitingCheckUserExistApi = false;

  mounted() {
    this.userId = this.localStorageUser.id;
    this.getAllInvitee();
    this.getAllInviteHistory();
  }

  async addMore(item) {
    if (!item.value || item.value.trim() == '') {
      this.isInvalid = true;
      return;
    }
    if (this.isMobile && !item.countryCode) {
      this.isInvalidCountryCode = true;
      return;
    }
    if (this.isInvalid || this.isInvalidCountryCode) {
      return;
    }
    if (this.isWaitingCheckUserExistApi) {
      return;
    }

    this.isWaitingCheckUserExistApi = true;
    const isExist = await this.checkUserExist(item);
    if (isExist) {
      this.isExist = true;
      return;
    }
    this.invitees.push({ value: '', countryCode: '' });
    this.dataValidated.push(item);
  }

  checkRegex(value) {
    this.isExist = false;
    if (this.isMobile) {
      const phoneNumber = value.trim().replace(' ', '');
      const pattern = new RegExp('\\b\\d{6,15}\\b');
      this.isInvalid = !pattern.test(phoneNumber);
    } else {
      const email = value.trim().replace(' ', '').replace(/\s+/g, '');
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isInvalid = !pattern.test(email.replace(/\.+(?=@)/g, ''));
    }
  }

  async checkUserExist(item) {
    return await this.registerService()
      .checkUsernameExisted(item.value, item.countryCode)
      .then(res => {
        return !!res.data;
      })
      .finally(() => {
        this.isWaitingCheckUserExistApi = false;
      });
  }

  choseSendMethod(isMobile = false) {
    this.isMobile = isMobile;
    this.isInvalid = false;
    this.isInvalidCountryCode = false;
    this.isExist = false;
    this.dataValidated = [];
    this.invitees = Array.from({ length: 1 }, () => ({ value: '', countryCode: '' }));
  }

  getAllInviteHistory() {
    this.invitationCodeService()
      .getAllInviteHistory()
      .then(res => {
        if (res.data) {
          this.notSignUps = res.data;
        }
      });
  }

  sendInvite() {
    if (this.dataValidated.length == 0) {
      return;
    }
    const historiesData = [];
    this.dataValidated.forEach(item => {
      if (item.value) {
        const inviteModel = new InviteHistory(this.userId);
        if (item.countryCode) {
          inviteModel.phoneNumber = item.value.trim();
          inviteModel.countryCode = item.countryCode;
        } else {
          inviteModel.email = item.value.trim();
        }
        historiesData.push(inviteModel);
      }
    });
    historiesData.forEach(item => {
      this.inviteAgain(item);
    });
  }

  getAllInvitee() {
    this.recentSignUps = [];
    this.invitationCodeService()
      .getAllInvitee()
      .then(res => {
        if (res.data) {
          const recentList = res.data;
          // @ts-ignore
          recentList.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          const unChecked = [];
          const checked = [];
          recentList.forEach((item, index) => {
            if (!item.isChecked) {
              unChecked.push(item);
            } else {
              checked.push(item);
            }
          });
          // return list;
          const indexes = [0, 3, 6];
          checked.forEach((item, index) => {
            if ((index + 1) % 2 === 0 && index !== 0) {
              this.recentSignUps.push(item);
              // get previous createdDate and plus 30 days
              const createdDate = recentList[index - 1].createdDate;
              const after30Days = new Date(createdDate);
              after30Days.setDate(after30Days.getDate() + 30);
              const duration =
                convertDateToCustomFormat(createdDate, 'yyyy-MM-dd') + ' ~ ' + convertDateToCustomFormat(after30Days, 'yyyy-MM-dd');
              this.recentSignUps.splice(indexes[0], 0, { ...item, isNotice: true, duration: duration });
              indexes.shift();
            } else {
              this.recentSignUps.push(item);
            }
          });
          this.recentSignUps = [...unChecked, ...this.recentSignUps];
          this.referralList.map((item, index) => {
            const val = this.recentSignUps[index];
            if (val) item.isActive = true;
            if ((index + 1) % 3 == 0 && index != 0) item.isNotice = true;
            return item;
          });
        }
      });
  }

  async inviteAgain(item: InviteHistory) {
    this.isLoading = true;
    const value = item.email ? item.email : item.phoneNumber;
    this.invitationCodeService()
      .sendInvite(item)
      .then(res => {
        if (res.data) {
          this.showResponseMessage(
            `${this.$t('toast.inviteFriend.success', { to: value })}`,
            `${this.$t('toast.title.success')}`,
            'success',
            3000
          );
        } else {
          this.showResponseMessage(
            `${this.$t('toast.inviteFriend.fail', { to: value })}`,
            `${this.$t('toast.title.success')}`,
            'success',
            3000
          );
        }
        this.getAllInviteHistory();
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
        this.showResponseMessage(`${this.$t('toast.inviteFriend.fail')}`, `${this.$t('toast.title.fail')}`, 'success', 3000);
      });
  }

  close() {}

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }
}
